import {
  TeamMemberChangeSectionDTO,
  TeamMemberChangeSectionRequest,
} from '../types/dto/team-member-change-section.dto';
import { TeamMemberChangeType } from '../types/team-member-changes';

export const mapTeamMemberChangeSectionFromDTO = (
  dto: TeamMemberChangeSectionDTO
): TeamMemberChangeType => {
  switch (dto) {
    case TeamMemberChangeSectionDTO.INFO:
      return TeamMemberChangeType.Info;
    case TeamMemberChangeSectionDTO.BILLING:
      return TeamMemberChangeType.Billing;
    case TeamMemberChangeSectionDTO.CAPACITY:
      return TeamMemberChangeType.Capacity;
    case TeamMemberChangeSectionDTO.INTEGRATIONS:
      return TeamMemberChangeType.Integration;
    default:
      return TeamMemberChangeType.Info;
  }
};

export const mapTeamMemberChangeTypeToDTO = (
  type: TeamMemberChangeType
): TeamMemberChangeSectionRequest => {
  switch (type) {
    case TeamMemberChangeType.Info:
      return TeamMemberChangeSectionDTO.INFO;
    case TeamMemberChangeType.Billing:
      return TeamMemberChangeSectionDTO.BILLING;
    case TeamMemberChangeType.Capacity:
      return TeamMemberChangeSectionDTO.CAPACITY;
    case TeamMemberChangeType.Integration:
      return TeamMemberChangeSectionDTO.INTEGRATIONS;
    default:
      return TeamMemberChangeSectionDTO.INFO;
  }
};
